import React from 'react'
import {Row, Col, Typography } from 'antd'
import UserProfile from './UserProfile';
import { useSelector } from 'react-redux'
import Orders from './Orders';
import Animate from 'rc-animate';

const { Title } = Typography;

const Profile = () => {
    const profile = useSelector(state => state.profile)

    return (
        <>
            <Row>
                <Title level={2}>
                    Profile & Details
                </Title>
            </Row>
        <Animate
            transitionName="fade"
            transitionAppear
        >
        <Row gutter={[24,16]}>
            <Col xs={24} sm={12} md={12} lg={10} xl={8} >
                <UserProfile profile={profile}/>
            </Col>
            <Col xs={24} sm={12} md={12} lg={10} xl={10} >
                <Orders />
            </Col>

        </Row>
        </Animate>
        </>
    )
}

export default Profile
